(function () {
  'use strict';

  if (typeof window.Splide === 'undefined') return;

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Parse the JSON options from data-splide (safe: JSON.parse, never eval). */
  function parseOptions(el) {
    var raw = el.getAttribute('data-splide');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      if (window.console) console.warn('carousel: invalid data-splide JSON', el, e);
      return {};
    }
  }

  /** Resolve the requested extensions from the loaded globals, skipping any that are absent. */
  function getExtensions(el) {
    var requested = (el.getAttribute('data-splide-features') || '').split(/\s+/);
    var available = (window.splide && window.splide.Extensions) || {};
    var extensions = {};
    if (requested.indexOf('video') > -1 && available.Video) extensions.Video = available.Video;
    if (requested.indexOf('url-hash') > -1 && available.URLHash) extensions.URLHash = available.URLHash;
    return extensions;
  }

  /** Respect prefers-reduced-motion: no autoplay, instant transitions. */
  function withMotionPrefs(options) {
    if (REDUCED_MOTION) {
      options.autoplay = false;
      options.speed = 0;
    }
    return options;
  }

  function mountSingle(el) {
    if (el.splide) return;
    var instance = new window.Splide(el, withMotionPrefs(parseOptions(el)));
    instance.mount(getExtensions(el));
    el.splide = instance;
    el.dispatchEvent(new CustomEvent('carousel:mounted', { bubbles: true, detail: { splide: instance } }));
  }

  /** Featured + thumbnail gallery: mount both, sync, then mount extensions. */
  function mountGallery(root) {
    var primaryEl = root.querySelector('[data-splide-primary]');
    var thumbsEl = root.querySelector('[data-splide-thumbs]');
    if (!primaryEl || !thumbsEl || primaryEl.splide) return;

    var primary = new window.Splide(primaryEl, withMotionPrefs(parseOptions(primaryEl)));
    var thumbs = new window.Splide(thumbsEl, withMotionPrefs(parseOptions(thumbsEl)));
    primary.sync(thumbs);
    primary.mount(getExtensions(primaryEl));
    thumbs.mount(getExtensions(thumbsEl));
    primaryEl.splide = primary;
    thumbsEl.splide = thumbs;
    root.dispatchEvent(
      new CustomEvent('carousel:mounted', { bubbles: true, detail: { splide: primary, thumbs: thumbs } })
    );
  }

  /** One broken carousel (e.g. invalid options make Splide throw) must not stop the others from mounting. */
  function safely(mount) {
    return function (el) {
      if (el.dataset.carouselFailed) return; // don't retry (and re-log) on the later init passes

      try {
        mount(el);
      } catch (e) {
        el.dataset.carouselFailed = 'true';

        if (window.console) console.error('carousel: failed to mount', el, e);
      }
    };
  }

  function init() {
    // Galleries first so their nested tracks are marked mounted before the single pass.
    document.querySelectorAll('[data-splide-gallery]').forEach(safely(mountGallery));
    document.querySelectorAll('.splide[data-splide]').forEach(safely(mountSingle));
  }

  // Initialize carousels when the DOM is ready, on window load, and on Shopify section load.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }

  document.addEventListener('shopify:section:load', init);
})();
